import { useTranslation } from "react-i18next";

import { PMSLocationPublicLinkDevices } from "./PMSLocationPublicLinkDevices";
import { PMSLocationPublicLinkSettings } from "./_components/PMSLocationPublicLinkSettings";
import { SettingsSectionTitle } from "./_components/PMSLocationSettingsFields";

// The access link tab: how the link behaves, then which devices it shows. The
// settings half used to sit at the bottom of the Settings tab, far from the
// devices they apply to.
export function PMSLocationPublicLink() {

    // LIBRARIES
    const { t } = useTranslation();

    return (
        <div className="w-100">
            <PMSLocationPublicLinkSettings />
            <div style={{ marginTop: "2rem" }} />
            <SettingsSectionTitle title={t("global_devices")} />
            <PMSLocationPublicLinkDevices />
        </div>
    );
}
